import React, { FC } from "react";
import Select from "react-select";
import {
  customStyles,
  EMPTY_STRING,
} from "../../../../../../../common/constants/common.constants";
import { Rarity } from "../../../../../../../common/enums/staking.enum";
import { IDetailNftData } from "../../../../../../../common/interfaces/common.interface";
import { IStakingAccountInfo } from "../../../../../../../common/interfaces/staking.interface";
import SkeletonItem from "../../../../../../SkeletonItem/SkeletonItem";
import NftSelectOption from "../NftSelectOption/NftSelectOption";

const DepositNfts: FC<{
  loadingNfts: boolean;
  chosenNft: IDetailNftData | undefined;
  setChosenNft: (e) => void;
  setWrongDepositAmount: (msg: string) => void;
  unqNfts: IDetailNftData[];
  stakingAccount: IStakingAccountInfo;
  availableRarities: Rarity[] | undefined;
}> = ({
  availableRarities,
  chosenNft,
  loadingNfts,
  setChosenNft,
  setWrongDepositAmount,
  stakingAccount,
  unqNfts,
}) => {
  return (
    <>
      {!loadingNfts ? (
        <>
          <Select
            styles={customStyles}
            value={chosenNft}
            options={unqNfts}
            onChange={(e) => {
              setChosenNft(e!);
              setWrongDepositAmount(EMPTY_STRING);
            }}
            isSearchable={false}
            formatOptionLabel={(nft: IDetailNftData) => {
              return <NftSelectOption nft={nft} />;
            }}
          />
          {stakingAccount.nftStakeRecord && (
            <p className="deposit-staking__nft-stake-info">
              <span
                className={`deposit-staking__nft-stake-info--${stakingAccount.nftStakeRecord.rarity}`}
              >
                {stakingAccount.nftStakeRecord.rarity}
              </span>{" "}
              NFT staked
            </p>
          )}
          {availableRarities && availableRarities.length > 0 && (
            <p className="deposit-staking__nft-stake-info">
              Available rarities:{" "}
              {availableRarities.map((item, index) => (
                <span>
                  {item.toString()}
                  {index < availableRarities.length - 1 && ","}{" "}
                </span>
              ))}
            </p>
          )}
          {stakingAccount.nftStakeRecord &&
            stakingAccount.nftStakeRecord.rarity === Rarity.Legendary && (
              <p className="deposit-staking__nft-stake-info">
                NFT with highest rarity is already staked, you can not stake
                your NFT.
              </p>
            )}
        </>
      ) : (
        <SkeletonItem height={60} borderRadius={8} />
      )}
    </>
  );
};

export default DepositNfts;
